import React, { memo } from 'react'

import { arrayOf, shape, string, oneOf } from 'prop-types'

import MegaRow from '../MegaRow/MegaRow'

// A single shaded filter column (Type or Budget): section header above a list of
// direct-link rows. These rows carry no chevron - they navigate straight to the
// filtered listing rather than opening a submenu.
function FilterColumn({ items, title, variant }) {
  return (
    <div
      className={`category-mega-menu__section category-mega-menu__section--${variant}`}
    >
      <h4 className="category-mega-menu__heading cgt-overline-md">{title}</h4>
      <div className="category-mega-menu__filter-list">
        {items.map((item) => (
          <MegaRow key={item.label} href={item.href} label={item.label} iconSlug={item.iconSlug} />
        ))}
      </div>
    </div>
  )
}

FilterColumn.propTypes = {
  items: arrayOf(shape({
    label: string.isRequired,
    iconSlug: string,
    href: string,
  })).isRequired,
  title: string.isRequired,
  variant: oneOf(['type', 'budget']).isRequired,
}

export default memo(FilterColumn)
